import React, { Fragment } from 'react'
import Component from 'components/component'
import DownloadSlider from 'components/download-slider-new'
import Checkbox from 'components/form/checkbox'
import { DI } from 'modules'
import withAnalytic from 'hoc/analytic'

// function getAgreementButtonComponent(agreement, user = {}) {
//     switch (agreement.agreement_type) {
//         case 'one_off':
//             return OneOffButton;
//         case 'pass':
//             return PassButton;
//         default:
//             return EnterpriseButton;
//     }
// }

export class BookEvent extends Component {
  state = {
    agreeRestrictions: false,
    openDrawer: false,
  }

  onChange = ev => {
    this.setState({
      agreeRestrictions: ev.target.checked,
    })
  }

  openDrawer = () => {
    const { selectedLanguageID, liveEvent } = this.props

    this.props.trackClick(
      {
        id: liveEvent.slug,
        title: liveEvent.title,
        live_language_id: selectedLanguageID,
      },
      'click_book_live'
    )

    this.setState({
      drawer: true,
    })
  }

  closeDrawer() {
    this.setState({
      drawer: false,
    })
  }

  onSubmit = (form, agreement) => {
    const { selectedLanguageID } = this.props
    this.props.actions.lives
      .bookLive(this.props.liveEvent.slug, {
        language_id: selectedLanguageID,
        agreement_id: form.agreement_id,
      })
      .then(resp => {
        this.closeDrawer()
        return resp
      })
  }

  render() {
    const { common, user } = this.props
    const { strings } = common
    const { selectedLanguageID, liveEvent } = this.props

    const geoBlock = liveEvent.blocked_countries_value_ids
      ? liveEvent.blocked_countries_value_ids.includes(
          user?.companyCountry?.id?.toString()
        )
      : false

    return (
      <Fragment>
        {liveEvent.restrictions && selectedLanguageID && (
          <div className="live-accept-restrictions">
            <Checkbox onChange={this.onChange}>
              {strings['page.lives.view.book.restrictions']}
            </Checkbox>
          </div>
        )}
        <div className="live-login">
          <button
            type="button"
            className="button"
            disabled={
              geoBlock ||
              (liveEvent.restrictions && !this.state.agreeRestrictions) ||
              !selectedLanguageID
            }
            onClick={() => this.openDrawer()}
          >
            {strings['page.lives.view.book.button']}
          </button>
        </div>
        {this.state.drawer && (
          <DownloadSlider
            onClose={() => this.closeDrawer()}
            languageId={selectedLanguageID}
            contentType="live"
            contentId={liveEvent.id}
            onSubmit={this.onSubmit}
            agreements={user.activeLiveAgreements.payload}
            entity={liveEvent}
            buttonText={strings['page.video.slider.book'] + ' ' + this.langName}
          />
        )}
      </Fragment>
    )
  }

  get langName() {
    const selectedLanguage =
      this.props.liveEvent.languages.find(
        item => item.id === this.props.selectedLanguageID
      ) || {}
    return selectedLanguage.name
  }
}

export default DI(['common', 'user', 'lives'])(
  withAnalytic(BookEvent, {
    groupEvent: 'ACTION_LIVE',
    trackData: {
      location: {
        page_layout: 'live_page',
        list: 'none',
      },
    },
  })
)
